/**
 * @file 常量相关
 * @author yanyiting@baidu.com
 */

export const NOT_IN_APP = {
    errno: 902,
    errmsg: 'APP外无法调用端能力'
};

export const COMMAND_NOT_EXIST = {
    errno: 901,
    errmsg: '不存在此端能力'
};

export const COMMAND_FAIL = {
    errno: 903,
    errmsg: '端能力调用失败'
};

export const COMMAND_RES_ERROR = {
    errno: 904,
    errmsg: '端能力返回参数格式错误',
    data: {}
};

export const COMMAND_SUCCESS = {
    errno: 0,
    errmsg: '调用成功'
};
